import React from 'react';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './infoChallenge.module.scss';
const cx = classnames.bind(styles);

interface InfoChallengeProps {
  positionDetail: PositionDetailVO;
}

const InfoChallenge = ({ positionDetail }: InfoChallengeProps) => {
  const {
    additionalInfo: { challenge },
  } = positionDetail;

  if (!challenge || challenge.challengeStatus === 'READY') return null;

  const getInfoText = () => {
    const isInfinity = challenge.applicableSize === null;

    if (!isInfinity) {
      return `이 포지션은 ${challenge.challengeName}에 포함되어 있으며, 동일한 채용이벤트 내에서 ${challenge.applicableSize}개의 포지션에 지원이 가능합니다.`;
    }

    return `이 포지션은 ${challenge.challengeName}에 포함되어 있으며, 동일한 채용이벤트 내에서 횟수 제한 없이 지원이 가능합니다.`;
  };

  const infoText = getInfoText();

  return <div className={cx('challengeInfo')}>{infoText}</div>;
};

export default InfoChallenge;
